import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import ProductRow from 'modules/finance/components/Quotes/QuotePhasesTable/_Body/ItemRowTimeAndMaterial/ProductRow'
import RoleRow from 'modules/finance/components/Quotes/QuotePhasesTable/_Body/ItemRowTimeAndMaterial/RoleRow'
import { QuotePricingLineItem } from 'modules/finance/components/Quotes/utils'

interface ItemRowTimeAndMaterialProps {
  item: QuotePricingLineItem
  currency: string
  isDraftStatus: boolean
  isJobCatalogTreeEnabled: boolean
  onUpdate: (updates: Partial<QuotePricingLineItem>) => void
  onDelete: () => void
}

const ItemRow = ({
  item,
  currency,
  isDraftStatus,
  isJobCatalogTreeEnabled,
  onUpdate,
  onDelete,
}: ItemRowTimeAndMaterialProps) => {
  const {
    access: { locale },
  } = useCurrentSession()

  if (item.type === 'role') {
    return (
      <RoleRow
        item={item}
        currency={currency}
        isDraftStatus={isDraftStatus}
        isJobCatalogTreeEnabled={isJobCatalogTreeEnabled}
        locale={locale}
        onUpdate={onUpdate}
        onDelete={onDelete}
      />
    )
  }

  return (
    <ProductRow
      item={item}
      currency={currency}
      isDraftStatus={isDraftStatus}
      locale={locale}
      onUpdate={onUpdate}
      onDelete={onDelete}
    />
  )
}

export default ItemRow
